


















































import Vue from 'vue'
import { fetchUserById, updateUser } from '../services/users-client'
import { UserShowData, UserUpdateData } from '../types'
import UsersForm from '../components/UsersForm.vue'
import AppBackToListButton from '@morpheus/utils/admin-vue/components/AppBackToListButton.vue'

export default Vue.extend({
  name: 'UsersEdit',
  components: {
    UsersForm,
    AppBackToListButton
  },
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data () {
    return {
      isLoading: false,
      user: {
        username: '',
        email: '',
        password: '',
        activated: false
      },
      showForm: false
    }
  },
  mounted () {
    this.$store.commit('global/setLoading', true)
    fetchUserById(this.id)
      .then((user: UserShowData) => {
        Vue.set(this, 'user', {
          username: user.username,
          email: user.email,
          password: user.password,
          activated: user.activated
        })
      })
      .catch(error => {
        this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
      })
      .finally(() => {
        this.showForm = true
        this.$store.commit('global/setLoading', false)
      })
  },
  methods: {
    onSubmit (user: UserUpdateData) {
      this.isLoading = true
      updateUser(user, this.id)
        .then(() => {
          this.clear()
          this.$store.commit('global/addNotification', {
            text: `You successfully edited user ${this.user.username}!`,
            type: 'success'
          })
        })
        .catch(error => {
          this.$store.commit('global/addNotification', { text: error.error, type: 'error' })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clear () {
      this.$validator.reset()
    }
  }
})
